// ─────────────────────────────────────────────────────────────────────────────
// A VIEW, NOT A SOURCE.
//
// The offer content that used to live here now lives in ./offers.js, alongside
// the other fourteen offers from the catalogue. This file is the subset of that
// catalogue which has a page, and it exists so that nothing had to be edited to
// follow the move: gatsby-node.js, Footer.js, SolutionsGrid.js,
// ServicePageOffers.js, both solution templates, /solutions/ and /pricing/ all
// keep importing `solutions` and reading the same field names.
//
// Every field these consumers touch — id, slug, name, group, industry, h1,
// metaTitle, metaDescription, oneLiner, whoFor, timeline, timelineShort,
// priceDisplay, priceShort, priceDetail, symptoms, included, notIncluded,
// process, commitments, weNeed, proof, faqs, related — is carried through
// unchanged in shape.
//
// To add a page: set `live: true` on that offer in offers.js. Nothing else.
//
// CommonJS on purpose. gatsby-node.js requires this file, and Gatsby 3 runs
// gatsby-node.js as plain Node without transpiling what it requires, so ESM
// `export` syntax fails the build with "Unexpected token 'export'". Webpack's
// interop means the React side still does
// `import { solutions } from "../data/solutions"` unchanged.
// ─────────────────────────────────────────────────────────────────────────────
const { offers } = require("./offers")

const solutions = offers.filter(o => o.live)

const getSolution = slug => solutions.find(s => s.slug === slug)

module.exports = { solutions, getSolution }
